import clsx from 'clsx'
import ImageWithFallback from './ImageWithFallback'

const sizes = {
  sm: { container: 'w-8 h-8', spinner: 'w-4 h-4', icon: 'w-3 h-3' },
  md: { container: 'w-12 h-12', spinner: 'w-6 h-6', icon: 'w-4 h-4' },
  lg: { container: 'w-16 h-16', spinner: 'w-8 h-8', icon: 'w-5 h-5' },
  xl: { container: 'w-24 h-24', spinner: 'w-12 h-12', icon: 'w-8 h-8' },
}

export default function LoadingSpinner({ size = 'md', className = '', showText = false }) {
  const sizeClasses = sizes[size]
  
  return (
    <div className={clsx('flex flex-col items-center justify-center space-y-4', className)}>
      {/* Just the Logo */}
      <div className="relative">
        <ImageWithFallback
          src="/images/zova_labs_right.png"
          alt="ZovaLabs Logo"
          className={clsx(
            'object-contain animate-gold-pulse',
            sizeClasses.icon
          )}
        />
      </div>
      
      {/* Loading Text */}
      {showText && (
        <div className="text-center">
          <div className="text-gray-300 font-medium animate-pulse">
            Loading...
          </div>
          <div className="flex items-center justify-center space-x-1 mt-2">
            <div className="w-1 h-1 bg-gold-400 rounded-full animate-pulse"></div>
            <div className="w-1 h-1 bg-gold-500 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
            <div className="w-1 h-1 bg-gold-600 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
          </div>
        </div>
      )}
    </div>
  )
}